import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui/button';
import { ApplePayLogo, GooglePayLogo } from '../../molecules';
import { StyledCheckoutButton, LogoContainer } from './styles';
import { PAYMENT_METHOD } from './constants';

export const CheckoutButton = ({
  paymentMethod = PAYMENT_METHOD.creditCard,
  isSubmitDisabled,
  isSubmitting,
  ctaText,
}) => {
  if (
    paymentMethod === PAYMENT_METHOD.applePay ||
    paymentMethod === PAYMENT_METHOD.googlePay
  ) {
    return (
      <StyledCheckoutButton
        variant="dark"
        disabled={isSubmitDisabled}
        fullWidth
        isLoading={isSubmitting}
        verticalPadding={2}
      >
        {ctaText} with
        {paymentMethod === PAYMENT_METHOD.applePay && (
          <LogoContainer>
            <ApplePayLogo size="large" />
          </LogoContainer>
        )}
        {paymentMethod === PAYMENT_METHOD.googlePay && (
          <LogoContainer>
            <GooglePayLogo size="large" />
          </LogoContainer>
        )}
      </StyledCheckoutButton>
    );
  }

  return (
    <Button
      disabled={isSubmitDisabled}
      fullWidth
      variant="spinach"
      isLoading={isSubmitting}
    >
      {ctaText}
    </Button>
  );
};

CheckoutButton.displayName = 'CheckoutButton';

CheckoutButton.propTypes = {
  paymentMethod: PropTypes.string.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  ctaText: PropTypes.string.isRequired,
};
